// extracted by mini-css-extract-plugin
export var chatHtmlText = "_n1-2";
export var chatLink = "_n1-0";
export var chatText = "_n1-1";